const serviceLinks = ['Event Production', 'DJ & Emcee Services', 'Audio & Sound Systems', 'Lighting Design', 'Video & Visual Displays', 'Live Event Support'];
const companyLinks = ['About Us', 'Service Areas', 'Testimonials', 'FAQ', 'Contact'];

const socials = [
  { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/DJBugsie', label: 'Facebook' },
  { icon: 'ri-instagram-line', href: 'https://www.instagram.com/bugsieproductions/', label: 'Instagram' },
  { icon: 'ri-pinterest-fill', href: 'https://www.pinterest.com/bugsie35/', label: 'Pinterest' },
  { icon: 'ri-star-line', href: 'https://www.yelp.com/biz/bugsie-productions-everett', label: 'Yelp' },
  { icon: 'ri-heart-2-line', href: 'https://www.weddingwire.com/biz/bugsie-productions-everett/80d2b012b13a5cab.html', label: 'WeddingWire' },
];

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#050505] border-t border-white/8">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">

          {/* Brand */}
          <div>
            <div className="mb-5">
              <img
                src="https://storage.readdy-site.link/project_files/0cb8efcd-9d2b-4dd1-9740-ad2e3153c9b7/d205aceb-a5bf-47b4-9517-1c4f4218b299_dj-logo.jpg?v=3b7c130c4994ae7a8692a9d96d877cdb"
                alt="Bugsie Productions"
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mb-6">
              Premier DJ &amp; event production serving Seattle and the Puget Sound region since 2001. Delivering unforgettable experiences with precision and passion.
            </p>
            <div className="flex items-center gap-3 flex-wrap">
              {socials.map(s => (
                <a key={s.label} href={s.href} target="_blank" rel="nofollow noreferrer" aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 text-gray-500 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all duration-300 cursor-pointer">
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-xs tracking-widest uppercase mb-5 pb-3 border-b border-[#D4AF37]/20">Services</h4>
            <ul className="space-y-3">
              {serviceLinks.map(s => (
                <li key={s}>
                  <a href="#services" onClick={(e) => { e.preventDefault(); scrollTo('#services'); }}
                    className="text-gray-600 hover:text-[#D4AF37] text-sm transition-colors duration-300 cursor-pointer flex items-center gap-2">
                    <i className="ri-arrow-right-s-line text-[#D4AF37]/40 text-xs"></i>
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold text-xs tracking-widest uppercase mb-5 pb-3 border-b border-[#D4AF37]/20">Company</h4>
            <ul className="space-y-3">
              {companyLinks.map(c => (
                <li key={c}>
                  <a href="#about" onClick={(e) => { e.preventDefault(); scrollTo('#about'); }}
                    className="text-gray-600 hover:text-[#D4AF37] text-sm transition-colors duration-300 cursor-pointer flex items-center gap-2">
                    <i className="ri-arrow-right-s-line text-[#D4AF37]/40 text-xs"></i>
                    {c}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-xs tracking-widest uppercase mb-5 pb-3 border-b border-[#D4AF37]/20">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a href="tel:2069319361" className="flex items-start gap-3 text-gray-500 hover:text-[#D4AF37] transition-colors duration-300 cursor-pointer">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-phone-fill text-[#D4AF37] text-sm"></i>
                  </div>
                  <span className="text-sm">(206) 931-9361</span>
                </a>
              </li>
              <li>
                <a href="mailto:info@bugsieproductions.com" className="flex items-start gap-3 text-gray-500 hover:text-[#D4AF37] transition-colors duration-300 cursor-pointer">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-mail-line text-[#D4AF37] text-sm"></i>
                  </div>
                  <span className="text-sm">info@bugsieproductions.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-500">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-[#D4AF37] text-sm"></i>
                </div>
                <span className="text-sm">PO Box 12397<br />Everett, WA 98206</span>
              </li>
              <li className="flex items-start gap-3 text-gray-500">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-time-line text-[#D4AF37] text-sm"></i>
                </div>
                <span className="text-sm">Tue–Thu: 10AM–4PM<br />Fri–Mon: Events Only</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/8 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-700 text-xs text-center sm:text-left">
            &copy; {new Date().getFullYear()} Bugsie Productions. All rights reserved.
          </p>
          <p className="text-gray-700 text-xs">
            Serving Seattle, Everett &amp; the Puget Sound Region Since 2001
          </p>
        </div>
      </div>
    </footer>
  );
}
